// extracted by mini-css-extract-plugin
module.exports = {"Pay":"Styles_Pay__p6EQ9","ProductRow":"Styles_ProductRow__3AG31"};